import get from 'lodash-es/get'

import { EMPTY_STRING } from '../../../../constants/common'
import i18n from '../../../../i18n'
import {
  isUserStatusActive,
  isUserStatusInvited,
  isUserStatusNotConfirmed,
} from '../../../../utils/user'

import {
  LOGIN_FORM_PHONE_NUMBER_SERVER_NON_FIELD_ERRORS,
  LOGIN_FORM_PHONE_VERIFICATION_SERVER_NON_FIELD_ERRORS,
} from './LoginFormPhone.constants'

export function parseLoginFormPhoneNumberServerError(error) {
  const errorText = get(error, ['response', 'data', 'errors'], EMPTY_STRING)

  if (LOGIN_FORM_PHONE_NUMBER_SERVER_NON_FIELD_ERRORS[errorText]) {
    return i18n.t(LOGIN_FORM_PHONE_NUMBER_SERVER_NON_FIELD_ERRORS[errorText])
  }

  return errorText
}

export function parseLoginFormPhoneVerificationServerError(error) {
  const errorText = get(error, ['response', 'data', 'errors'], EMPTY_STRING)

  if (LOGIN_FORM_PHONE_VERIFICATION_SERVER_NON_FIELD_ERRORS[errorText]) {
    return i18n.t(
      LOGIN_FORM_PHONE_VERIFICATION_SERVER_NON_FIELD_ERRORS[errorText]
    )
  }

  return errorText
}

export function isUserStatusValid(status) {
  return (
    isUserStatusActive(status) ||
    isUserStatusInvited(status) ||
    isUserStatusNotConfirmed(status)
  )
}
